import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compare } from '../actions/';

class Compare extends Component {

    constructor(props) {
        super(props);
    }

    onButtonClick() {
        const { modele, reprod } = this.props

        this.props.compare({ modele, reprod })
    }
    render() {
        return (
            <button
                onClick={this.onButtonClick.bind(this)}
                className="btn btn-success"
                title="Vérifier si le tracé est bien identique modèle">
                <span className="glyphicon glyphicon-ok"></span>
            </button>
        );
    }
}

const mapStateToProps = ({ activeModele, coloredSquares }) => {
    return {
        modele: activeModele.squares,
        reprod: coloredSquares
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({ compare }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Compare)
